import { render, staticRenderFns } from "./fuiou.vue?vue&type=template&id=424e7c4f&scoped=true"
import script from "./fuiou.vue?vue&type=script&lang=js"
export * from "./fuiou.vue?vue&type=script&lang=js"
import style0 from "./fuiou.vue?vue&type=style&index=0&id=424e7c4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e7c4f",
  null
  
)

export default component.exports